/**
 * Created by klyachb1 on 23/02/2017.
 */
import {Injectable} from '@angular/core';
import {CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import {LoginService} from '../shared/services/login.service';
import {Router} from '@angular/router';

export abstract class CanActivateBase implements CanActivate {
  isApplicationOffline = false;
  constructor(protected loginService: LoginService, protected router: Router) {
    this.loadSettings();
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.doActivate(route, state);
  }

  abstract doActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot);

  loadSettings(): void {
    const me: any = this;
    this.loginService.loadSettings().subscribe((vars: any) => {
        me.isApplicationOffline = vars.isApplicationOffline;
        if (me.isApplicationOffline) {
          me.router.navigate(['/offline']);
        }
      }, err => {
        console.log(err);
      }
    );
  }
}

@Injectable()
export class CanActivateViaAuthGuard extends CanActivateBase {
  constructor(protected loginService: LoginService, protected router: Router) {
    super(loginService, router);
  }

  doActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.loginService.isUserLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
      return false;
    }
  }
}

@Injectable()
export class CanActivateViaGeneralGuard extends CanActivateBase {
  constructor(protected loginService: LoginService, protected router: Router) {
    super(loginService, router);
  }

  doActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.isApplicationOffline) {
      this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/can-activate-via-auth-guard.ts